import { Kbd as ChakraKbd, type KbdProps as ChakraKbdProps } from '@chakra-ui/react'
import { forwardRef } from 'react'

export interface Props extends ChakraKbdProps {}

export default forwardRef<HTMLDivElement, Props>((props, ref) => {
  return (
    <ChakraKbd
      ref={ref}
      borderRadius="xs"
      fontWeight={600}
      colorPalette="gray"
      variant="raised"
      {...props}
    />
  )
})
